"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CloseButton = void 0;
var _react = _interopRequireDefault(require("react"));
var _Button = _interopRequireDefault(require("@material-ui/core/Button"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _styles = require("@material-ui/core/styles");
var _closeIcon = _interopRequireDefault(require("./assets/close-icon.svg"));
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
const useStyles = (0, _styles.makeStyles)({
  button: {
    padding: 0,
    background: "transparent !important",
    minWidth: 0
  }
});
const StyledButton = (0, _styledComponents.default)(_Button.default)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  > span:first-child {\n    padding: 0;\n  }\n  .MuiButton-startIcon {\n    margin: 0;\n  }\n"])));
const CloseButton = props => {
  const classes = useStyles();
  const {
    className,
    ...others
  } = props;
  return /*#__PURE__*/_react.default.createElement(StyledButton, _extends({
    startIcon: /*#__PURE__*/_react.default.createElement("img", {
      src: _closeIcon.default,
      alt: ""
    }),
    className: [classes.button, className || ""].join(" ")
  }, others));
};
exports.CloseButton = CloseButton;